var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_2848)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_2848",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_2848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.001 0H-12V24.0005H36.001V0Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 0V2.68333L30.6345 24.0006H36.001V21.3173L-6.63349 8.00016e-05L-12 0ZM36.001 0V2.68325L-6.63349 24.0005H-12V21.3172L30.6345 0H36.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0004 0V24.0005H16.0006V0H8.0004ZM-12 8.00016V16.0003H36.001V8.00016H-12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 9.60019V14.4003H36.001V9.60019H-12ZM9.60043 0V24.0005H14.4005V0H9.60043Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 24.0005L4.00032 16.0003H7.57799L-8.42233 24.0005H-12ZM-12 0L4.00032 8.00016H0.422649L-12 1.78892L-12 0ZM16.423 8.00016L32.4233 0H36.001L20.0006 8.00016H16.423ZM36.001 24.0005L20.0006 16.0003H23.5783L36.001 22.2116V24.0005Z",
    fill: "#CC0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_2848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag_uk.19fbe5e09723970843b54196b2dac6a2.svg";
export { ForwardRef as ReactComponent };